export const easeInOutQuint = `cubic-bezier(0.860, 0.000, 0.070, 1.000)`
export const easeInOutQuart = `cubic-bezier(0.770, 0.000, 0.175, 1.000)`
export const easeInOutCubic = `cubic-bezier(0.645, 0.045, 0.355, 1.000)`
export const easeInQuint = `cubic-bezier(0.64, 0, 0.78, 0)`
export const easeOutQuint = `cubic-bezier(0.22, 1, 0.36, 1)`
